import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { logout } from "../Redux/Reducers/authSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const Header = () => {
  const userName = useSelector((state) => state.auth.user);

  const dispatch = useDispatch();

  const navigate = useNavigate()
  const handlelogout = () => {
    toast.success('Logout Sucessfully')
    dispatch(logout());
    sessionStorage.removeItem("story_id")
  };
   const handleSettings=()=>{
    navigate("/settings")
  }
  return (
    <div className="p-6 w-full min-h-[122px]">
      <div className="flex items-center justify-end gap-3">
        
        <div>
          {/* <img src='../assets/images/user.png' />
            <span>{userName.name}</span> */}

          <Menu as="div" className="relative inline-block text-left">
            <div >
              <MenuButton className="inline-flex w-full justify-center  rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900  ring-inset ring-gray-300">
                <img src="../assets/images/uservector.jpg" className=" h-16 w-16"/>
              </MenuButton>
            </div>

            <MenuItems
              transition
              className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
            >
              <div className="py-1">
                <MenuItem className='cursor-pointer hover:bg-gray-100 transition-[0.5s] bg-white' onClick={handleSettings} >
                <div className="flex items-center">
                <img src="./assets/images/settings.png" className=" w-6 h-6 ml-3 "/>
                 <p className="block px-2 py-3 text-sm text-gray-700">Settings</p>
                </div>
                </MenuItem>
                <MenuItem className='cursor-pointer hover:bg-gray-100 transition-[0.5s] bg-white' onClick={handlelogout} >
                <div className="flex items-center">
                <img src="./assets/images/log-out.png" className=" w-6 h-6 ml-4 "/>

                <p className="block px-2 py-3 text-sm text-gray-700">Logout</p>
                </div>
                </MenuItem>
              </div>
            </MenuItems>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default Header;
